import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

/**
 * tailwind-merge only knows Tailwind's own theme scales. The design-system
 * shadow tokens (`shadow-float`, `shadow-float-lg` — Story 24.2,
 * `src/index.css` `--shadow-float*`) are custom, so without this registration a
 * caller passing `shadow-float` over a primitive's `shadow-md` did NOT replace
 * it: both classes survived and the stylesheet order decided (`.shadow-md`
 * won — Story 24.5's AvatarMenu shipped shadcn's grey shadow that way).
 * Registering the two tokens on the `shadow` scale puts them in the same class
 * group as `shadow-*`, so the later (caller's) shadow wins as expected.
 */
const twMerge = extendTailwindMerge({
  extend: { theme: { shadow: ["float", "float-lg"] } },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
